import React, { Component } from 'react';

import CanvasMenuButton from 'components/canvasEditor/menu/CanvasMenuButton';
import { FILE_IMAGE_EXTENSIONS } from 'modules/file/constants';
import { blobToFile } from 'modules/file/helpers';
import PropTypes from 'prop-types';

import { UploadProptypes } from '@hotmart/club-files-ui';

export default class CanvasImageUpload extends Component {
  imageController = React.createRef();

  static propTypes = {
    fileUpload: UploadProptypes.fileUpload,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    icon: PropTypes.string,
    toolTip: PropTypes.string,
    label: PropTypes.string
  };

  static defaultProps = {
    className: '',
    icon: '',
    toolTip: '',
    label: ''
  };

  clickInput = () => {
    this.imageController.current.click();
  };

  shouldCleanInputToAcceptRepeated = () => {
    this.imageController.current.value = null;
  };

  _handleInputFileChange = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const file = e.target.files[0];

    this.shouldCleanInputToAcceptRepeated();

    file && this.saveFile(file);
  };

  saveFile = (blob) => {
    const { fileUpload } = this.props;
    const timestamp = Date.now();
    const file = blobToFile(blob, blob.name, timestamp, 'image/jpeg');

    /*
      File properties that aren't present in the Blob proto will not be read by the file uploader
      worker, which means that any additional params(name, last modified) need to be passed on as the
      options param.
    */
    const options = {
      name: file.name,
      lastModifiedDate: file.lastModifiedDate
    };

    fileUpload.actions.sendMultiples([file], options);
  };

  render() {
    const { disabled, className, icon, toolTip, label } = this.props;

    return (
      <div>
        <CanvasMenuButton
          disabled={disabled}
          onClick={this.clickInput}
          className={className}
          icon={icon}
          toolTip={toolTip}
          label={label}
        />
        <input
          className="hidden"
          ref={this.imageController}
          type="file"
          accept={FILE_IMAGE_EXTENSIONS}
          onChange={this._handleInputFileChange}
          name="imageSubmitter"
        />
      </div>
    );
  }
}
